"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkStatementBatchPatient_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var BulkStatementBatch_1 = require("./BulkStatementBatch");
var BulkStatementBatchPatient_Factory = /** @class */ (function () {
    function BulkStatementBatchPatient_Factory() {
    }
    BulkStatementBatchPatient_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AdministrativeFeeWaived: model.AdministrativeFeeWaived,
            BatchId: model.BatchId,
            BulkStatementBatch: BulkStatementBatch_1.BulkStatementBatch_Factory.CreateIncoming(model.BulkStatementBatch),
            Excluded: model.Excluded,
            Notes: model.Notes,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    BulkStatementBatchPatient_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AdministrativeFeeWaived: model.AdministrativeFeeWaived,
            BatchId: model.BatchId,
            BulkStatementBatch: BulkStatementBatch_1.BulkStatementBatch_Factory.CreateOutgoing(model.BulkStatementBatch),
            Excluded: model.Excluded,
            Notes: model.Notes,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return BulkStatementBatchPatient_Factory;
}());
exports.BulkStatementBatchPatient_Factory = BulkStatementBatchPatient_Factory;
